import { oc } from "@orpc/contract";
import { z } from "zod";
import { FieldProvenanceSchema } from "@erp/shared-types";

/** Source document descriptor for the annotation editor (signed URL + kind). */
const AnnotationDocumentSchema = z.object({
  id: z.uuid(),
  originalFileName: z.string(),
  mimeType: z.string().nullable(),
  url: z.string(),
  kind: z.enum(["pdf", "image", "xlsx", "emailBody"]),
});

const DocumentProvenanceResponseSchema = z.object({
  documents: z.array(AnnotationDocumentSchema),
  fields: z.array(FieldProvenanceSchema),
});

export type DocumentProvenanceResponse = z.infer<
  typeof DocumentProvenanceResponseSchema
>;

export const annotationContracts = {
  // Bounding boxes + signed URL for a document, used by the annotation editor's
  // optional document overlay. `fields` is empty when no Extend citations exist.
  getDocumentProvenance: oc
    .input(z.object({ stepRunId: z.uuid(), documentId: z.uuid() }))
    .output(DocumentProvenanceResponseSchema)
    .route({
      method: "GET",
      summary: "Get extracted field locations in a document",
      description:
        "For a workflow step run's source document, returns a signed view link, document kind, and the bounding boxes showing where each extracted field came from.",
    }),
};
